import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from '@gatsbyjs/reach-router';
import { Alert } from '@printdeal/ui-library';
import { Location } from '../../../../../types/Location';
import useProductQuoteData from '../../../../../hooks/useProductQuoteData';
import { dynamicQuoteMessage } from '../../../../../helpers/segmentedCustomerHelper';

// @ts-expect-error
import { selectors as customerSelectors } from '../../../../../store/slices/customerSlice';

const QuoteCreatedAlert = () => {
  const customerGroupId: string = useSelector(customerSelectors.getCustomerGroupId);
  const [contentfulProductQuote] = useProductQuoteData(customerGroupId);
  const location: Location = useLocation() as Location;
  const { state = {} } = location;

  if (!state?.quoteCreated) {
    return null;
  }

  if (contentfulProductQuote) {
    // TODO: why was this needed, and does this still serve a real purpose?
    const { quoteConfirmationMessage } = contentfulProductQuote.quoteConfirmationMessage;
    return (
      <Alert variant="success" isDismissible data-hj-suppress>
        {quoteConfirmationMessage.quoteConfirmationMessage}
      </Alert>
    );
  }

  return (
    <Alert variant="success" isDismissible data-hj-suppress>
      <FormattedMessage
        id="quotes.created.success.withTime"
        defaultMessage="Your offer has been requested! you will receive a response from us within {responseTime} hours on info@drukwerkdeal.nl"
        values={{
          responseTime: dynamicQuoteMessage(),
        }}
      />
    </Alert>
  );
};

export default QuoteCreatedAlert;
